import { createStore } from '../createStore';

export interface SessionData {
  isLoaded: boolean;
  isAuthorized: boolean | null;
  email: string | null;
  paymentModel: string | null;
  planName: string | null;
  themeID: string | null;
  versionID: string | null;
  versions?: {
    createdAt: string;
    filesUrl: string;
    id: string;
    launcherVersion: string;
    thumbnailUrl: string;
    url: string;
  }[];
  images?: {
    createdAt: string;
    id: string;
    name: string | null;
    tag: string | null;
    url: string;
  }[];
}

export const sessionDefault: SessionData = {
  isLoaded: true,
  isAuthorized: null,
  email: null,
  paymentModel: null,
  planName: null,
  themeID: null,
  versionID: null,
  versions: [],
  images: [],
};

export const [UserSessionStoreProvider, useSessionStore] = createStore<SessionData>(sessionDefault);
